import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useStyle } from 'react-native-style-utilities';

import { LoadingPlaceholder, theme, useNavbarContainerHeight, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const ShareLineItemLoadingPlaceholder = () => {
  const { currentBreakpoint, match, minWidth } = useResponsive();
  const { top } = useSafeAreaInsets();
  const { height: navbarHeight } = useNavbarContainerHeight();

  // ─── Flags ───────────────────────────────────────────────────────────

  const shouldApplyNavbarSpacing = minWidth.isSM;
  const shouldApplyAndroidSafeAreaTop = Platform.OS === 'android' && currentBreakpoint.isXS;

  // ─── Styles ──────────────────────────────────────────────────────────

  const navbarSpacingStyles = useStyle(
    () =>
      shouldApplyNavbarSpacing ? { paddingTop: navbarHeight + theme.spacing['10'] } : undefined,
    [navbarHeight, shouldApplyNavbarSpacing],
  );
  const innerContainerDynamicStyles = useStyle(() => {
    if (shouldApplyAndroidSafeAreaTop) {
      return { paddingTop: top + theme.spacing['10'] };
    }
  }, [shouldApplyAndroidSafeAreaTop, top]);

  const innerContainerStyles = [
    styles.innerContainer,
    match([undefined, styles.innerContainerSM]),
    navbarSpacingStyles,
    innerContainerDynamicStyles,
  ];

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View style={styles.container}>
      <View style={innerContainerStyles}>
        <View style={styles.header}>
          <LoadingPlaceholder
            rows={1}
            rowHeight={44}
            borderRadius={theme.spacing['2']}
            palette="cream"
            style={styles.loadingPlaceholder}
          />
        </View>

        <View style={styles.contentContainer}>
          <LoadingPlaceholder
            rows={1}
            rowHeight={420}
            borderRadius={theme.spacing['6']}
            palette="cream"
            style={styles.loadingPlaceholder}
          />
        </View>
      </View>
    </View>
  );
};

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
  },
  innerContainer: {
    width: '100%',
    backgroundColor: theme.colors.APP_BACKGROUND,
    paddingVertical: theme.spacing['10'],
    paddingHorizontal: theme.spacing['4'],
    alignItems: 'center',
  },
  innerContainerSM: {
    maxWidth: 380,
    paddingHorizontal: theme.spacing['6'],
  },
  header: {
    width: '100%',
  },
  contentContainer: {
    width: '100%',
    alignItems: 'center',
    paddingTop: theme.spacing['6'],
    paddingBottom: theme.spacing['10'],
  },
  loadingPlaceholder: {
    width: '100%',
  },
});
